module.exports = __webpack_public_path__ + "img/pic8.05e2e921.jpg";